/* Master list of tool/app integrations exposed by Clinic OS.
   Used by:
     - Home page IntegrationsSlider (infinite marquee)
     - /integrations TOOLS grid
   Logos prefer cdn.simpleicons.org (brand-colored SVGs).
   For brands removed from / not on simpleicons CDN, fall back to Google s2 favicon. */

export const INTEGRATIONS = [
  // Social
  { name: "Facebook",           category: "Social", logo: "https://cdn.simpleicons.org/facebook" },
  { name: "Instagram",          category: "Social", logo: "https://cdn.simpleicons.org/instagram" },
  { name: "X",                  category: "Social", logo: "https://cdn.simpleicons.org/x" },
  { name: "TikTok",             category: "Social", logo: "https://cdn.simpleicons.org/tiktok" },
  { name: "LinkedIn",           category: "Social", logo: "https://www.google.com/s2/favicons?domain=linkedin.com&sz=128" },
  { name: "WhatsApp",           category: "Social", logo: "https://cdn.simpleicons.org/whatsapp" },
  { name: "Google My Business", category: "Social", logo: "https://www.google.com/s2/favicons?domain=business.google.com&sz=128" },

  // Ads / Marketing
  { name: "Google Ads", category: "Ads & Marketing", logo: "https://cdn.simpleicons.org/googleads" },
  { name: "Meta Ads",   category: "Ads & Marketing", logo: "https://cdn.simpleicons.org/meta" },
  { name: "Mailchimp",  category: "Ads & Marketing", logo: "https://cdn.simpleicons.org/mailchimp" },
  { name: "HubSpot",    category: "Ads & Marketing", logo: "https://cdn.simpleicons.org/hubspot" },

  // Calendars
  { name: "Google Calendar",  category: "Calendars", logo: "https://cdn.simpleicons.org/googlecalendar" },
  { name: "Outlook Calendar", category: "Calendars", logo: "https://www.google.com/s2/favicons?domain=outlook.live.com&sz=128" },
  { name: "Apple Calendar",   category: "Calendars", logo: "https://cdn.simpleicons.org/apple" },
  { name: "Calendly",         category: "Calendars", logo: "https://cdn.simpleicons.org/calendly" },

  // Video & Voice
  { name: "Google Meet", category: "Video & Voice", logo: "https://cdn.simpleicons.org/googlemeet" },
  { name: "Zoom",        category: "Video & Voice", logo: "https://cdn.simpleicons.org/zoom" },
  { name: "Twilio",      category: "Video & Voice", logo: "https://www.google.com/s2/favicons?domain=twilio.com&sz=128" },

  // Messaging
  // (Slack moved to Productivity)

  // Payments
  { name: "Stripe", category: "Payments", logo: "https://cdn.simpleicons.org/stripe" },

  // Accounting
  { name: "QuickBooks", category: "Accounting", logo: "https://cdn.simpleicons.org/quickbooks" },
  { name: "Xero",       category: "Accounting", logo: "https://cdn.simpleicons.org/xero" },
  { name: "Wave",       category: "Accounting", logo: "https://www.google.com/s2/favicons?domain=waveapps.com&sz=128" },

  // E-commerce
  { name: "Shopify",     category: "E-commerce", logo: "https://cdn.simpleicons.org/shopify" },
  { name: "WooCommerce", category: "E-commerce", logo: "https://cdn.simpleicons.org/woocommerce" },

  // Productivity
  { name: "Google",          category: "Productivity", logo: "https://cdn.simpleicons.org/google" },
  { name: "Slack",           category: "Productivity", logo: "https://www.google.com/s2/favicons?domain=slack.com&sz=128" },
  { name: "Google Contacts", category: "Productivity", logo: "https://www.google.com/s2/favicons?domain=contacts.google.com&sz=128" },
  { name: "Google Forms",    category: "Productivity", logo: "https://cdn.simpleicons.org/googleforms" },

  // Automation
  { name: "Zapier",         category: "Automation", logo: "https://cdn.simpleicons.org/zapier" },
  { name: "Make",           category: "Automation", logo: "https://cdn.simpleicons.org/make" },
  { name: "Pabbly Connect", category: "Automation", logo: "https://www.google.com/s2/favicons?domain=pabbly.com&sz=128" },
];

/* Stable key for data-testids */
export const integrationTestId = (name) =>
  name.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
